/*
 * @Author: wangzhijun wangzhijun@dataoceanai.com
 * @Date: 2022-10-18 17:13:37
 * @LastEditors: wangzhijun wangzhijun@dataoceanai.com
 * @LastEditTime: 2022-10-19 11:22:33
 * @FilePath: \supplier_side\src\utils\modal.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { Modal } from "antd";
import "./index.less";
//语言切换
import intl from "react-intl-universal";

export function messageModal(mess) {
  Modal.info({
    content: (
      <div className="message-modal">
        <h1>{intl.get("Tips_f41babef-2238-24b3-8e39-bdb7bcb07d16")}</h1>
        <p>{mess}</p>
      </div>
    ),
    okText: intl.get("Confirm_fc189f71-934f-2caa-bd8f-29b9460afa19"),
    centered: true,
    bodyStyle: {
      padding: '24px!important',
    },
    onOk() {},
  });
}
